var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dplayerEle",on:{"click":_vm.dplayerClick}},[(_vm.config.isForbidden)?_c('div',{staticClass:"Markups",class:{'active': _vm.show}}):_vm._e(),_vm._v(" "),_c('div',{ref:"dplayer",staticClass:"dplayer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f12ab7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dplayer/dplayer.vue
// module id = null
// module chunks = 